<template>
  <div class="register-success-page">
    <a-card class="register-success-content">
      <a-icon class="registerSucceed-content-img" type="check-circle" theme="filled"/>
      <div class="register-success-content-success">{{ $t('registerSuccess') }}！</div>
      <div class="register-success-content-title">{{ $t('registerSuccessHint') }}</div>
      <a-button class="register-success-content-button" size="large" @click="$router.push(`companyRegister`)">{{ $t('enterpriseCertification') }}
      </a-button>
    </a-card>
  </div>
</template>

<script>
import loginHeader from '../../components/common/login-header';

export default {
  name: "registerSuccess",
  components: {loginHeader},
}
</script>

<style lang="scss">
.register-success-page {
  .register-success-content {
    width: 990px;
    margin: 48px auto;
    padding: 28px 0;
    background-color: #ffffff;
    height: 416px;
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;

    .registerSucceed-content-img {
      color: #1F6CBA;
      font-size: 66px;
    }

    .register-success-content-img {
      height: 66px;
      width: 66px;
    }

    .register-success-content-success {
      font-size: 24px;
      font-weight: 400;
      color: #333333;
      margin-top: 26px;
    }

    .registerSucceed-content-title {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      margin-top: 35px;
    }

    .register-success-content-title {
      font-size: 18px;
      font-weight: 400;
      color: #333333;
      margin-top: 35px;
    }

    .register-success-content-button {
      background: #1F6CBA;
      color: #FFFFFF;
      margin-top: 28px;
      font-size: 16px;
      border: 0;
    }
  }
}

</style>